import { render, staticRenderFns } from "./RestoreCartModal.vue?vue&type=template&id=2074c369&"
import script from "./RestoreCartModal.vue?vue&type=script&lang=js&"
export * from "./RestoreCartModal.vue?vue&type=script&lang=js&"
import style0 from "./RestoreCartModal.vue?vue&type=style&index=0&id=2074c369&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports